export function formatCurrency(value) {
  if (value == null) return 'R$ –';
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}

export function formatDate(dateStr) {
  if (!dateStr) return '–';
  try {
    const d = new Date(dateStr);
    return d.toLocaleDateString('pt-BR');
  } catch {
    return dateStr;
  }
}

export function formatDatetime(dateStr) {
  if (!dateStr) return '–';
  try {
    const d = new Date(dateStr);
    return d.toLocaleString('pt-BR');
  } catch {
    return dateStr;
  }
}

export function formatDateISO(dateStr) {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr);
    return d.toISOString().split('T')[0];
  } catch {
    return dateStr;
  }
}

export const STATUS_COLORS = {
  'Recebido': 'bg-blue-100 text-blue-800',
  'Em Produção': 'bg-yellow-100 text-yellow-800',
  'Pronto': 'bg-green-100 text-green-800',
  'Em Entrega': 'bg-orange-100 text-orange-800',
  'Entregue': 'bg-emerald-100 text-emerald-800',
  'Cancelado': 'bg-red-100 text-red-800',
  'Pendente': 'bg-gray-100 text-gray-700',
  'Ativo': 'bg-green-100 text-green-800',
  'Inativo': 'bg-red-100 text-red-700',
};
